<script>
  import { createEventDispatcher } from 'svelte';

  export let icon = '';
  export let title = '';

  const dispatch = createEventDispatcher();
</script>

<button on:click>
  {#if icon}
    <span class="material-icons"> {icon} </span>
  {/if}
  {title}
</button>

<style src="./actionMenuItem.scss"></style>
